import React, { useRef } from "react";

import {FormTextInput} from "UIComponents/InputTextField";
import { Button } from "@toddle-edu/ds-web";

import classes from "./SchoolCodeForm.scss";

const SchoolCodeForm = props => {
  const {
    updateCurrentScreen,
    userType,
    updateInputField,
    role,
    isNewLoginFlowEnabled,
    data: { schoolcode },
    renderBackButtonComponent,
    customStyle: { headerStyleV2, subTextStyle } = {},
    onGoToSchoolWorkspaceClick,
    renderTradeMarkText,
  } = props;

  const inputRefs = {
    schoolcode: useRef(),
  };

  const onBackClick = () => {
    updateInputField({});

    switch (userType) {
      case "staff":
        updateCurrentScreen({ type: "teacherLogin" });
        break;
      case "student":
        updateCurrentScreen({ type: "studentLogin" });
        break;
      case "parent":
        updateCurrentScreen({ type: "parentLogin" });
        break;
      default:
        updateCurrentScreen({ type: "loginHome" });
    }
  };

  const getBackButtonText = () => {
    if (isNewLoginFlowEnabled) {
      return "Go back";
    }
    switch (userType) {
      case "student":
        return "Student account";
      case "staff":
        if (role === "visitor") return "Visitor account";
        return "Teacher account";
      case "parent":
        return "Family account";
      default:
        return "Toddle home";
    }
  };

  const containerStyle = {
    paddingTop: "19.5%",
  };

  return (
    <div className={classes.container} style={containerStyle}>
      <div>
        {renderBackButtonComponent({
          onClick: onBackClick,
          buttonText: getBackButtonText(),
          ariaLabel: "Go back to usertype selection screen",
        })}
        <div style={headerStyleV2}>{"Find your school"}</div>
        <div style={subTextStyle}>
          {"Enter your school’s short code to find its workspace on Toddle"}
        </div>
        <div className={classes.innerContainer}>
          <div className={classes.inputContainer}>
            <FormTextInput
              dsVersion="2.0"
              data-test-id="input-login-schoolcode"
              ref={ref => (inputRefs["schoolcode"] = ref)}
              textInputLabel={"School’s short code*"}
              value={schoolcode}
              name={"schoolcode"}
              placeholder={"Type school code here"}
              updateInputField={updateInputField}
              error={"Enter school code"}
              size={"large"}
              autoComplete={"off"}
              autoFocus="true"
              onEnter={onGoToSchoolWorkspaceClick}
            />
          </div>
          <div className={classes.bottomContainer}>
            <Button
              dsVersion="2.0"
              data-test-id="button-sign-in"
              variant={"destructive"}
              size={"large"}
              onClick={onGoToSchoolWorkspaceClick}
              isFullWidth={true}
              disabled={!schoolcode}
            >
              {"Go to school workspace"}
            </Button>
          </div>
        </div>
      </div>
      <div>
        {renderTradeMarkText({
          align: "left",
        })}
      </div>
    </div>
  );
};

export default SchoolCodeForm;
